module.exports = __webpack_public_path__ + "static/media/logo_jump.4476cc21.svg";